import { FundamentalMovement } from '../../../../Generated/Raven-Demeter';
import { parseFieldConfidences } from '../articleActions';
import { ArticleWithRating } from './NewsDefinitions';

export interface ColumnScore {
    direction: 'bull' | 'bear' | 'neutral';
    magnitude: number;
}

export const computeColumnScore = (
    pairs: ArticleWithRating[],
    getMovement: (pair: ArticleWithRating) => FundamentalMovement | undefined,
    confidenceField: 'supply' | 'demand' | 'sentiment',
): ColumnScore => {
    if (pairs.length === 0) {
        return { direction: 'neutral', magnitude: 0 };
    }

    const invertForPrice = confidenceField === 'supply';

    let weightedSum = 0;
    pairs.forEach((pair) => {
        const movement = getMovement(pair);
        const fc = parseFieldConfidences(pair.rating.comments);
        const confidence = fc[confidenceField] ?? pair.rating.confidenceScore ?? 0.5;

        if (movement === FundamentalMovement.Increase) {
            weightedSum += invertForPrice ? -confidence : confidence;
        } else if (movement === FundamentalMovement.Decrease) {
            weightedSum += invertForPrice ? confidence : -confidence;
        }
    });

    const netScore = weightedSum / pairs.length;

    if (Math.abs(netScore) < 0.02) {
        return { direction: 'neutral', magnitude: Math.abs(netScore) };
    }

    return {
        direction: netScore > 0 ? 'bull' : 'bear',
        magnitude: Math.abs(netScore),
    };
};
